import { isNull } from "./helpers";

export const requiredMsg = (name) => {
  return `${name} tidak boleh kosong`;
};

export const isError = (obj) => {
  return isNull(obj) ? false : true;
};

export const isMessageError = (obj) => {
  return isNull(obj) ? "" : obj;
};
